import styled from 'styled-components'

const MusicStyle = styled.div`
	--mPaddingV: var(--sp15x);
	--mTitleMarginBottom: var(--sp4x);
	--mSubtitleMarginBottom: var(--sp6x);
	--mMiddleInfoMarginBottom: var(--sp10x);
	--mMiddleInfoBgSize: var(--sp109x);
	--mImageSize: var(--sp91x);
	--mInfoVPositionFromCenter: var(--sp15x);
	--mCenterCircleSize: var(--sp7x);
	--mPlayBtnSize: var(--sp13x);
	--mPlayBtnIconSize: var(--sp4x);
	--mNextBtnWidth: var(--sp9x);
	--mNextBtnHeight: var(--sp7x);
	--mNextBtnIconSize: var(--sp3x);
	--mActionBtnMarginH: var(--sp3x);

	position: relative;
	text-align: center;
	padding: var(--mPaddingV) 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	opacity: 1;

	/* @supports (-webkit-touch-callout: none) {
        &.loading {
            pointer-events: none;
            animation: loading 1s infinite;
        }
    } */

	.music-title {
		margin-bottom: var(--mTitleMarginBottom);
	}

	.music-subtitle {
		margin-bottom: var(--mSubtitleMarginBottom);
	}

	.music-middle-info-cont {
		position: relative;
		width: var(--mMiddleInfoBgSize);
		height: var(--mMiddleInfoBgSize);
		margin-bottom: var(--mMiddleInfoMarginBottom);
		z-index: 1;

		.music-middle-info-bg {
			position: relative;
			display: block;
			width: 100%;
			height: 100%;
			border-radius: 50%;
			z-index: 1;

			&:before {
				content: '';
				position: absolute;
				inset: 0;
				z-index: 1;
				background: var(--primaryColor3);
				opacity: 0.2;
				border-radius: 50%;
			}

			&:after {
				content: '';
				position: absolute;
				inset: 0;
				z-index: -1;
				background: var(--bgCobalt);
				border-radius: 50%;
			}
		}

		.music-image {
			--imagePaddingTop: 0;

			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: var(--mImageSize);
			height: var(--mImageSize);
			border-radius: 50%;
			overflow: hidden;
			z-index: 2;
		}

		.music-middle-info {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			max-width: var(--mImageSize);
			max-height: var(--mImageSize);
			z-index: 2;
		}

		.music-item {
			&-title,
			&-artist {
				position: absolute;
				max-width: 50%;
				left: 50%;
				transform: translateX(-50%);
				z-index: 2;
			}

			&-artist {
				bottom: calc(50% + var(--mInfoVPositionFromCenter));
			}

			&-title {
				top: calc(50% + var(--mInfoVPositionFromCenter));
			}
		}

		&:after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: var(--mCenterCircleSize);
			height: var(--mCenterCircleSize);
			background: var(--primaryColor3);
			border-radius: 50%;
			z-index: 2;
		}
	}

	.music-action-buttons-cont {
		display: flex;
		align-items: center;
		justify-content: center;

		.music-btn {
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0 calc(var(--mActionBtnMarginH) / 2);
			transition: transform var(--trTime);
			transform: scale(1);
			backface-visibility: hidden;

			&.music-icon-play {
				width: var(--mPlayBtnSize);
				height: var(--mPlayBtnSize);
				border-radius: 50%;
				font-size: var(--mPlayBtnIconSize);
			}

			&.music-icon-prev {
				i {
					transform: rotate(180deg);
				}
			}

			&.music-icon-prev,
			&.music-icon-next {
				width: var(--mNextBtnWidth);
				height: var(--mNextBtnHeight);
				font-size: var(--mNextBtnIconSize);
				border-radius: var(--sp2x);

				&.disabled {
					opacity: 0.5;
					pointer-events: none;
				}
			}

			@media (hover: hover) {
				&:hover:not(.normal) {
					transform: scale(1.1);
				}
			}

			i {
				backface-visibility: hidden;
			}
		}
	}

	.equalizer {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100vw;
		height: 150%;
		transform: translate(-50%, -50%);
		pointer-events: none;
		z-index: -1;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--mPaddingV: var(--sp12x);
		--mTitleMarginBottom: var(--sp2x);
		--mSubtitleMarginBottom: var(--sp4x);
		--mMiddleInfoMarginBottom: var(--sp8x);
		--mMiddleInfoBgSize: var(--sp82x);
		--mImageSize: var(--sp68x);
		--mInfoVPositionFromCenter: var(--sp12x);
		--mCenterCircleSize: var(--sp6x);
		--mPlayBtnSize: var(--sp10x);
		--mPlayBtnIconSize: var(--sp3x);
		--mNextBtnWidth: var(--sp7x);
		--mNextBtnHeight: var(--sp5x);
		--mNextBtnIconSize: var(--sp2x);
		--mActionBtnMarginH: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--mPaddingV: var(--sp10x);
		--mTitleMarginBottom: var(--sp3x);
		--mSubtitleMarginBottom: var(--sp5x);
		--mMiddleInfoMarginBottom: var(--sp8x);
		--mMiddleInfoBgSize: var(--sp65x);
		--mImageSize: var(--sp54x);
		--mInfoVPositionFromCenter: var(--sp11x);
		--mCenterCircleSize: var(--sp5x);
		--mPlayBtnSize: var(--sp8x);
		--mPlayBtnIconSize: var(--sp2x);
		--mNextBtnWidth: var(--sp6x);
		--mNextBtnHeight: var(--sp5x);
		--mNextBtnIconSize: var(--sp2x);
		--mActionBtnMarginH: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--mPaddingV: var(--sp10x);
		--mTitleMarginBottom: var(--sp3x);
		--mSubtitleMarginBottom: var(--sp4x);
		--mMiddleInfoMarginBottom: var(--sp7x);
		--mMiddleInfoBgSize: var(--sp61x);
		--mImageSize: var(--sp51x);
		--mInfoVPositionFromCenter: var(--sp9x);
		--mCenterCircleSize: var(--sp5x);
		--mPlayBtnSize: var(--sp7x);
		--mPlayBtnIconSize: var(--sp2x);
		--mNextBtnWidth: var(--sp5x);
		--mNextBtnHeight: var(--sp4x);
		--mNextBtnIconSize: var(--sp1-5x);
		--mActionBtnMarginH: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--mPaddingV: var(--sp8x);
		--mTitleMarginBottom: var(--sp3x);
		--mSubtitleMarginBottom: var(--sp4x);
		--mMiddleInfoMarginBottom: var(--sp5x);
		--mMiddleInfoBgSize: var(--sp55x);
		--mImageSize: var(--sp46x);
		--mInfoVPositionFromCenter: var(--sp8x);
		--mCenterCircleSize: var(--sp4x);
		--mPlayBtnSize: var(--sp7x);
		--mPlayBtnIconSize: var(--sp2x);
		--mNextBtnWidth: var(--sp5x);
		--mNextBtnHeight: var(--sp4x);
		--mNextBtnIconSize: var(--sp1-5x);
		--mActionBtnMarginH: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--mPaddingV: var(--sp7x);
		--mTitleMarginBottom: var(--sp2x);
		--mSubtitleMarginBottom: var(--sp3x);
		--mMiddleInfoMarginBottom: var(--sp4x);
		--mMiddleInfoBgSize: var(--sp43x);
		--mImageSize: var(--sp36x);
		--mInfoVPositionFromCenter: var(--sp5x);
		--mCenterCircleSize: var(--sp3x);
		--mPlayBtnSize: var(--sp6x);
		--mPlayBtnIconSize: var(--sp2x);
		--mNextBtnWidth: var(--sp4x);
		--mNextBtnHeight: var(--sp3x);
		--mNextBtnIconSize: var(--sp1-5x);
		--mActionBtnMarginH: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--mPaddingV: var(--sp7x);
		--mTitleMarginBottom: var(--sp2x);
		--mSubtitleMarginBottom: var(--sp3x);
		--mMiddleInfoMarginBottom: var(--sp4x);
		--mMiddleInfoBgSize: var(--sp43x);
		--mImageSize: var(--sp36x);
		--mInfoVPositionFromCenter: var(--sp5x);
		--mCenterCircleSize: var(--sp3x);
		--mPlayBtnSize: var(--sp6x);
		--mPlayBtnIconSize: var(--sp2x);
		--mNextBtnWidth: var(--sp4x);
		--mNextBtnHeight: var(--sp3x);
		--mNextBtnIconSize: var(--sp1-5x);
		--mActionBtnMarginH: var(--sp2x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--mPaddingV: var(--sp7x);
		--mTitleMarginBottom: var(--sp2x);
		--mSubtitleMarginBottom: var(--sp3x);
		--mMiddleInfoMarginBottom: var(--sp4x);
		--mMiddleInfoBgSize: var(--sp31x);
		--mImageSize: var(--sp26x);
		--mInfoVPositionFromCenter: var(--sp3x);
		--mCenterCircleSize: var(--sp2x);
		--mPlayBtnSize: var(--sp5x);
		--mPlayBtnIconSize: var(--sp1-5x);
		--mNextBtnWidth: var(--sp4x);
		--mNextBtnHeight: var(--sp3x);
		--mNextBtnIconSize: var(--sp1x);
		--mActionBtnMarginH: var(--sp2x);
	}
`

export default MusicStyle
